module.exports = __webpack_public_path__ + "static/media/Zapier-Third-Image.d1a0ca7c.jpg";